import React, { useEffect, useMemo, useState } from "react";
import "@/app/globals.css";

interface LogoAnimationProps {
  width?: number;
  height?: number;
  message?: string;
}

const LogoAnimation: React.FC<LogoAnimationProps> = ({
  width = 50,
  height = 50,
  message,
}: LogoAnimationProps) => {
  const loadingText = useMemo(() => {
    const trimmed = (message || "").trim();
    if (!trimmed) return "Loading...";
    if (/^loading\b/i.test(trimmed)) return trimmed;
    return `Loading ${trimmed}...`;
  }, [message]);

  return (
    <div className="w-full h-full min-h-[20vh] flex items-center justify-center">
      <div role="status" aria-live="polite" className="text-center">
        <svg
          id="kovaad-logo"
          className="kovaad-logo-animation mx-auto"
          width={width}
          height={height}
          viewBox="0 0 37 39"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className="path-color1"
            d="M10.2185 7.4879C24.3446 2.02998 36.7157 15.5351 29.8349 28.0357L30.5913 33.0417L26.5167 32.1103C20.5817 38.0705 9.51602 36.6547 4.6311 29.4323C7.92647 36.1045 18.0931 41.3622 27.8557 35.6022L34.317 36.6499L33.2106 30.1311C42.224 13.5452 24.353 -1.07239 10.2185 7.4879Z"
          />
          <path
            className="path-color1"
            d="M32.5836 7.84515C34.4843 7.84515 36.0252 6.30428 36.0252 4.40353C36.0252 2.50278 34.4843 0.961914 32.5836 0.961914C30.6828 0.961914 29.142 2.50278 29.142 4.40353C29.142 6.30428 30.6828 7.84515 32.5836 7.84515Z"
          />
          <path
            className="path-color2"
            d="M3.02236 11.5889C4.557 11.5889 5.80107 10.3448 5.80107 8.8102C5.80107 7.27556 4.557 6.03149 3.02236 6.03149C1.48772 6.03149 0.243652 7.27556 0.243652 8.8102C0.243652 10.3448 1.48772 11.5889 3.02236 11.5889Z"
          />
          <path
            className="path-color2"
            d="M23.3221 8.78363C14.389 3.92629 1.04806 16.8452 8.56064 26.9495C11.0397 30.2845 15.8467 31.3298 19.5556 29.5196C22.3031 28.1794 23.8375 25.4391 23.798 22.411C23.7548 19.033 21.4472 15.7987 18.2681 14.6563C22.4482 15.7783 25.5949 19.9584 25.5182 24.2871C25.4403 28.6146 22.1461 32.6796 17.9277 33.6505C14.9056 34.347 11.6438 33.5391 9.0725 31.8057C5.63808 29.4897 3.37723 25.5194 3.13868 21.3837C2.53571 10.9198 14.1924 3.8196 23.3209 8.78363H23.3221Z"
          />
          <path
            className="path-color2"
            d="M17.8354 26.4616C19.0337 26.4616 20.0051 25.4901 20.0051 24.2918C20.0051 23.0935 19.0337 22.1221 17.8354 22.1221C16.6371 22.1221 15.6656 23.0935 15.6656 24.2918C15.6656 25.4901 16.6371 26.4616 17.8354 26.4616Z"
          />
        </svg>
        <span className="block mt-2 mx-auto">{loadingText}</span>
      </div>
    </div>
  );
};

export default LogoAnimation;
